module.exports = __webpack_public_path__ + "media/images/Ohortense-6a9010523e07af84c6aa8c4863da27e8.svg";